// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PSlT3A {
    display: none;
}

.aspXfg {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px 90px 30px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: -8px -7px 20px 0 rgba(0, 0, 0, 0.1);

    &:focus-visible {
        outline: none;
    }
}

.aspXfg *:focus-visible
{
    box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #116dff !important;
    z-index: 999 !important;
}

.WSh558 {
    width: 66.6%;
    margin: 0;
    padding: 0;
    text-align:left;
    font-size: 14px;
    line-height: 21px;
}

.Mu3mRO {
    margin: 0;
    padding: 0;
    text-align:left;
    font-size: 14px;
    line-height: 21px;
}

.uzfsxJ {
    flex-shrink: 1;
    padding: 0;
    padding-left: 40px;
    display: flex;
    list-style: none;

    margin: 0;
}

.kxpWWV {
    white-space: nowrap;
    margin: 0 0 0 19px;
    padding: 0;
}

.R0_LWY {
    position: absolute;
    right: 10px;
    top: 10px;
}

@media (max-width: 1110px) {
    .aspXfg {
        padding-left: 30px;
        padding-right: 30px;
        justify-content: flex-start;
    }

    .uzfsxJ {
        flex-grow: 1;
        justify-content: center;
    }
}

@media (max-width: 834px) {
    .aspXfg {
        padding-right: 56px;
        flex-direction: column;
        align-items: flex-end;
    }

    .WSh558 {
        width: auto;
    }

    .uzfsxJ {
        margin-top: 24px;
        justify-content: flex-end;
    }
}

@media (max-width: 750px) {
    .NuVImH {
        display: none;
    }

    .PSlT3A {
        display: inline;
    }

    .aspXfg {
        padding: 18px 18px 24px 18px;
        border-radius: 6px 6px 0 0;
    }

    .WSh558 {
        font-size: 12px;
        line-height: 18px;
        padding-right: 20px;
    }

    .uzfsxJ {
        justify-content: flex-end;
    }

    .EMS834 {
        flex-direction: row-reverse;
    }

    .kxpWWV {
        margin: 0 0 0 24px;
    }

    .kxpWWV:first-child {
        margin: 0;
    }

    .uzfsxJ button {
        height: 32px;
        font-size: 12px;
        min-width: 48px;
        text-align: center;
        display: unset;
        line-height: 26px;
        text-underline-offset: 5px;
    }

    .EMS834 .kxpWWV {
        margin: 0 0 0 15px;
    }
}

@media (max-height: 320px) {
    .aspXfg {
        display: none;
    }
}

@media (max-height: 570px) or (max-width: 320px){
    .NuVImH {
        display: none;
    }

    .PSlT3A {
        display: inline;
    }

    .aspXfg {
        padding: 14px 14px 14px 14px;
        border-radius: 6px 6px 0 0;
    }

    .WSh558 {
        font-size: 12px;
        line-height: 14px;
        padding-right: 15px;
    }

    .uzfsxJ {
        margin-top: 10px;
        padding-left: 0px;
        justify-content: flex-end;
    }

    .EMS834 {
        flex-direction: row-reverse;
    }

    .kxpWWV:first-child {
        margin: 0;
    }

    .uzfsxJ button {
        font-size: 12px !important;
        min-width: 10px;
        text-align: center;
        display: unset;
        line-height: 12px;
        text-underline-offset: 5px;
    }

    .EMS834 .kxpWWV {
        margin: 0 0 0 8px;
    }

    .R0_LWY {
        position: absolute;
        right: 10px;
        top: 10px;
    }
}

`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visibleOnMobile": `PSlT3A`,
	"banner": `aspXfg`,
	"content": `WSh558`,
	"cipaContent": `Mu3mRO`,
	"actions": `uzfsxJ`,
	"action": `kxpWWV`,
	"close": `R0_LWY`,
	"hiddenOnMobile": `NuVImH`,
	"decline-all": `EMS834`,
	"declineAll": `EMS834`
};
export default ___CSS_LOADER_EXPORT___;
